import { render } from "./SidebarItems.vue?vue&type=template&id=47b20be8&scoped=true"
import script from "./SidebarItems.vue?vue&type=script&lang=js"
export * from "./SidebarItems.vue?vue&type=script&lang=js"

import "./SidebarItems.vue?vue&type=style&index=0&id=47b20be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b20be8"]])

export default __exports__